module.exports = __webpack_public_path__ + "static/media/turkey.ad1ad8b3.svg";